import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsPrinterDeleteParm } from "./wsPrinterDeleteParm";
import { wsPrinterToggleActiveParm } from "./wsPrinterToggleActiveParm";

@Injectable()
export class DataService_printermaint {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PrintersSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	PrintersSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "PhotoID/PrintersSelectList";

		var promise$ = this.httpclientService.post(url, SchoolID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PrinterDelete
	//
	//-----------------------------------------------------------------------------------------------------
	PrinterDelete(parms: wsPrinterDeleteParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/PrinterDelete";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PrinterToggleActive
	//
	//-----------------------------------------------------------------------------------------------------
	PrinterToggleActive(parms: wsPrinterToggleActiveParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/PrinterToggleActive";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
